import React from 'react'

const SuccesCase = () => {
  return (
    <section className='bg-beige relative overflow-hidden  flex flex-col w-full items-center w-full pt-28' id="choose-style">
      <div className="w-full m-auto text-center">
        <h2 className="font-tiempo  text-azul font-semibold text-5xl">
          See how to succeed with custom packaging
        </h2>
        <p className='font-basis font-bold text-gray-1 text-center px-8 py-4 md:w-3/5 mx-auto text-xl'>
          Watch how Father Time Bread is slicing up the competition by delivering the ultimate unboxing experience with fresh bread shipped directly to customers in custom printed boxes.
        </p>
      </div>
      <div>
        <div className="w-96 h-96 bg-black flex justify-center items-center my-48 text-white text-4xl">
          Video
        </div>
      </div>
    </section>
  )
}

export default SuccesCase
